module.exports = __webpack_public_path__ + "img/sfondo_login.ddc62488.png";